import { find } from 'lodash-es';
import { EMPTY, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';

import type { Program } from '@core/types';

// Consts
import { PROGRAMS_CONFIG } from '@consts/programs-config';

@Injectable({ providedIn: 'root' })

export class ProgramsResolve implements Resolve<Program> {

  constructor(
    private router: Router,
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<Program | never> {
    const { username, program } = route.params;
    const currentProgram: Program = find(PROGRAMS_CONFIG, (item: Program) => item.name === program);

    if (currentProgram) {
      return of(currentProgram);
    }

    if (username) {
      this.router.navigate([username]);
    } else {
      this.router.navigate(['/']);
    }

    return EMPTY;
  }

}
